import React from "react";
import globalStyles from "../../constants/globalStyles/theme.json";
import * as S from "./Styles";

const { spacing } = globalStyles;

interface ButtonLinkProps {
  href: string;
  children?: React.ReactNode;
  arrowIcon?: boolean;
}

const ButtonLink: React.FC<ButtonLinkProps> = ({ href, children, arrowIcon }) => {
  return (
    <S.StyledButtonLink to={href}>
      {children}
      {arrowIcon && (
        <S.AnimatedIcon
          style={{
            marginLeft: spacing.space2,
            width: "18px",
            height: "18px",
          }}
        />
      )}
    </S.StyledButtonLink>
  );
};

export default ButtonLink;
